"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var warn_1 = require("@uifabric/utilities/lib/warn");
var GlobalSettings_1 = require("@uifabric/utilities/lib/GlobalSettings");
var index_1 = require("@uifabric/merge-styles/lib/index");
var ICON_SETTING_NAME = 'icons';
var _icons = GlobalSettings_1.GlobalSettings.getValue(ICON_SETTING_NAME, {
    __options: {
        warnOnMissingIcons: true
    },
    __remapped: {}
});
/**
 * Registers a given subset of icons.
 *
 * @param iconSubset - the icon subset definition.
 */
function registerIcons(iconSubset) {
    var subset = tslib_1.__assign({}, iconSubset, { isRegistered: false, className: undefined });
    var icons = iconSubset.icons;
    for (var iconName in icons) {
        if (icons.hasOwnProperty(iconName)) {
            var code = icons[iconName];
            var normalizedIconName = iconName.toLowerCase();
            if (_icons[normalizedIconName]) {
                warn_1.warn("Icon '" + iconName + " being re-registered");
            }
            _icons[normalizedIconName] = {
                code: code,
                subset: subset
            };
        }
    }
}
exports.registerIcons = registerIcons;
/**
 * Remaps one icon name to another.
 */
function registerIconAlias(iconName, mappedToName) {
    _icons.__remapped[iconName.toLowerCase()] = mappedToName.toLowerCase();
}
exports.registerIconAlias = registerIconAlias;
/**
 * Gets an icon definition. If an icon is requested but the subset has yet to be registered,
 * it will get registered immediately.
 *
 * @public
 * @param name - Name of icon.
 */
function getIcon(name) {
    var icon = undefined;
    name = name ? name.toLowerCase() : '';
    name = _icons.__remapped[name] || name;
    if (name) {
        icon = _icons[name];
        if (icon) {
            var subset = icon.subset;
            if (!subset.isRegistered) {
                // Register font face for given icons.
                index_1.fontFace(subset.fontFace);
                // Generate a base class name for the given font.
                subset.className = index_1.mergeStyles(subset.style, {
                    fontFamily: subset.fontFace.fontFamily,
                    fontWeight: subset.fontFace.fontWeight || 'normal',
                    fontStyle: subset.fontFace.fontStyle || 'normal'
                }).toString();
                subset.isRegistered = true;
            }
        }
        else {
            if (_icons.__options.warnOnMissingIcons) {
                warn_1.warn("The icon \"" + name + "\" was referenced but not registered.");
            }
        }
    }
    return icon;
}
exports.getIcon = getIcon;
/**
 * Sets the icon options.
 *
 * @public
 */
function setIconOptions(options) {
    _icons.__options = tslib_1.__assign({}, _icons.__options, options);
}
exports.setIconOptions = setIconOptions;
//# sourceMappingURL=icons.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/icons/~/@uifabric/styling/lib/utilities/icons.js
// module id = ../node_modules/@uifabric/icons/node_modules/@uifabric/styling/lib/utilities/icons.js
// module chunks = 1